import { combineReducers } from 'redux';
import { ADDRESS_STATE_KEY, addressReducer } from './address/address-reducer';
import { LOCATIONS_STATE_KEY, locationsReducer } from '../components/offices/offices-reducer';
import { AUDIT_STATE_KEY, auditReducer } from '../components/audit/audit-reducer';
import { USER_STATE_KEY, userReducer } from './user/user-reducer';
import { coordinatesReducer, LOCATIONS_COORDINATES_STATE_KEY } from '../components/map/map-reducer';
import { SCHEDULES_STATE_KEY, schedulesReducer } from './schedule/schedule-reducer';
import { DOCTORS_STATE_KEY, doctorsReducer } from '../components/doctors/doctors-reducer';
import { headerReducer, HEADER_EXPORT_STATE_KEY } from '../components/header/header-reducer';
import { COMMON_STATE_KEY, commonReducer } from './common/common-reducer';
import { STATISTICS_STATE_KEY, statisticsReducer } from '../components/statistics/statistics-reducer';
import { VENDORS_STATE_KEY, vendorsReducer } from '../components/vendors/vendors-reducer';
import { TABS_EXPORT_STATE_KEY, tabsExportReducer } from '../components/export/export-reducer';
import { IMPORT_2_STATE_KEY, importReducer } from '../components/import/import-reducer';
import { hooAccomodationsReducer } from '../components/HooAccommodations/reducer';
import { HOO_ACCOMODATION_STATE_KEY } from '../components/HooAccommodations/selectors';
// Import default reducer and the exported state key constant from the user role config reducer
import userRoleConfigReducer, { USER_ROLE_CONFIG_STATE_KEY } from '../components/UserRoleConfiguration/reducer';
import { callForwardingReducer, CALL_FORWARDING_STATE_KEY } from '../components/CallForwardingSnapshot/reducer';
import {
  BRANDED_FIXTURES_STATE_KEY,
  brandedFixturesReducer,
} from '../components/branded-fixtures/branded-fixtures-reducer';

const rootReducer = combineReducers({
  [ADDRESS_STATE_KEY]: addressReducer,
  [LOCATIONS_STATE_KEY]: locationsReducer,
  [AUDIT_STATE_KEY]: auditReducer,
  [USER_STATE_KEY]: userReducer,
  [LOCATIONS_COORDINATES_STATE_KEY]: coordinatesReducer,
  [SCHEDULES_STATE_KEY]: schedulesReducer,
  [DOCTORS_STATE_KEY]: doctorsReducer,
  [HEADER_EXPORT_STATE_KEY]: headerReducer,
  [COMMON_STATE_KEY]: commonReducer,
  [VENDORS_STATE_KEY]: vendorsReducer,
  [STATISTICS_STATE_KEY]: statisticsReducer,
  [TABS_EXPORT_STATE_KEY]: tabsExportReducer,
  [IMPORT_2_STATE_KEY]: importReducer,
  [HOO_ACCOMODATION_STATE_KEY]: hooAccomodationsReducer,
  [USER_ROLE_CONFIG_STATE_KEY]: userRoleConfigReducer,
  [CALL_FORWARDING_STATE_KEY]: callForwardingReducer,
  [BRANDED_FIXTURES_STATE_KEY]: brandedFixturesReducer,
});

export default rootReducer;
